<template>
  <!-- Navbar -->
  <nav
    id="navbarMenu"
    class="navbar navbar-expand-xxl navbar-light bg-white text-uppercase my-auto position-fixed top-0 py-0 px-xxl-5 px-md-4 px-sm-4 px-3 w-100"
    style="z-index: 9999; height:100px; overflow:hidden;"
  >
    <a
      class="navbar-brand"
      @click="goTo('HomePage')"
    ><img
      :src="`${laravel_url}assets/images/site-logo.png`"
      class="site-logo"
      alt=""
    ></a>
    <!-- <button
      class="navbar-toggler border-0 shadow-none"
      type="button"
      data-bs-toggle="modal"
      data-bs-target="#myModal"
    >
      <span class="navbar-toggler-icon" />
    </button>
    <div
      id="myModal"
      class="modal"
      role="dialog"
      tabindex="-1"
    >
      <div class="modal-dialog modal-fullscreen-xxl-down">
        <div class="modal-content">
          <div
            class="modal-header my-auto border-0"
            style="height:100px;"
          >
            <a
              class="navbar-brand"
              @click="goTo('HomePage')"
            >
              <img
                :src="`${laravel_url}assets/images/site-logo.png`"
                class="site-logo"
                alt=""
              >
            </a>
            <div class="row align-items-center">
              <div class="col acc-img pro-det-right">
                <a href="login.html"><img :src="`${laravel_url}assets/images/Group 10.png`"></a>
              </div>
              <div class="col con-vbag">
                <a
                  @click="goTo('ShoppingCart')"
                ><img :src="`${laravel_url}assets/images/Group 9.png`"><span class="cart-m-basket d-flex align-items-center justify-content-center">{{ cart_length }}</span></a>
              </div>
            </div>
          </div>
          <div class="modal-body border-0 animate-menu">
            <ul class="navbar-nav m-auto">
              <li class="nav-item px-3">
                <a
                  data-bs-toggle="modal"
                  data-bs-target="#myModal"
                  class="nav-link"
                  @click="goTo('About')"
                >ABOUT</a>
              </li>
              <li class="nav-item px-3">
                <a
                  data-bs-toggle="modal"
                  data-bs-target="#myModal"
                  class="nav-link"
                  @click="goTo('ProductList')"
                >SHOP ASC</a>
              </li>
              <li class="nav-item px-3">
                <a
                  data-bs-toggle="modal"
                  data-bs-target="#myModal"
                  class="nav-link"
                  @click="goTo('Service')"
                >SERVICE</a>
              </li>
              <li class="nav-item px-3">
                <a
                  data-bs-toggle="modal"
                  data-bs-target="#myModal"
                  class="nav-link"
                  @click="goTo('Gallery')"
                >GALLERY</a>
              </li>
              <li class="nav-item px-3">
                <a
                  data-bs-toggle="modal"
                  data-bs-target="#myModal"
                  class="nav-link"
                  @click="goTo('Client')"
                >CLIENTS</a>
              </li>
              <li class="nav-item px-3">
                <a
                  data-bs-toggle="modal"
                  data-bs-target="#myModal"
                  class="nav-link"
                  @click="goTo('Contact')"
                >CONTACT</a>
              </li>
              <li class="nav-item px-3" />
            </ul>
          </div>
          <div class="modal-footer border-0">
            <button
              type="button"
              class="btn-close shadow-none"
              data-bs-dismiss="modal"
              aria-label="Close"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="collapse navbar-collapse py-5">
      <ul class="navbar-nav m-auto">
        <li class="nav-item px-3">
          <a
            class="nav-link"
            @click="goTo('About')"
          >ABOUT</a>
        </li>
        <li class="nav-item px-3">
          <a
            class="nav-link"
            @click="goTo('ProductList')"
          >SHOP ASC</a>
        </li>
        <li class="nav-item px-3">
          <a
            class="nav-link"
            @click="goTo('Service')"
          >SERVICE</a>
        </li>
        <li class="nav-item px-3">
          <a
            class="nav-link"
            @click="goTo('Gallery')"
          >GALLERY</a>
        </li>
        <li class="nav-item px-3">
          <a
            class="nav-link"
            @click="goTo('Client')"
          >CLIENTS</a>
        </li>
        <li class="nav-item px-3">
          <a
            class="nav-link"
            @click="goTo('Contact')"
          >CONTACT</a>
        </li>
      </ul>
      <a href="login.html"><img
        :src="`${laravel_url}assets/images/Group 8.png`"
        class="xl-none acc-img"
      ></a>
    </div>
    <a
      class="nav-link bag-des xl-none"
      @click="toShoppingCart"
    >VIEW BAG<span class="cart-basket d-flex align-items-center justify-content-center">{{ cart_length }}</span>
    </a> -->
  </nav>
  <!-- /.navbar -->
</template>

<script>
export default {
  name: 'Header',
  data: function () {
    return {
      lang: 'EN',
      username: localStorage.getItem('fs_user'),
      user_id: localStorage.getItem('fs_user_id'),
      fs_username: localStorage.getItem('fs_username'),
      laravel_url: window.LARAVEL_URL
    }
  },
  computed: {
    cart () {
      return this.$store.state.Cart.rows
    },
    cart_length () {
      return this.$store.state.Cart.rows.length.toString()
    }
  },
  mounted () {
    if (localStorage.fs_lang) {
      this.lang = localStorage.fs_lang
    }
  },
  methods: {
    logout () {
      return this.$store.dispatch('Auth/logout', this.authInfo)
        .then(() => {
          this.$router.push({ name: 'Login' })
        })
        .catch(err => this.throwReject(err))
    },
    openNav () {
      var sidebar = document.getElementById('sidebar')
      if (sidebar.classList.contains('sidebar-collapse')) {
        sidebar.classList.replace('sidebar-collapse', 'sidebar-open')
      } else {
        sidebar.classList.replace('sidebar-open', 'sidebar-collapse')
      }
    },
    goTo (name) {
      if (this.$route.name !== name) this.$router.push({ name: name })
    },
    toHome () {
      if (this.$route.name !== 'HomePage') this.$router.push({ name: 'HomePage' })
      else this.$router.go()
    },
    toShoppingCart () {
      if (this.$route.name !== 'ShoppingCart') this.$router.push({ name: 'ShoppingCart' })
      else this.$router.go()
    },
    toLogin () {
      this.$router.push({ name: 'Login' })
    },
    doSwitchLang (val) {
      this.lang = val
      localStorage.setItem('fs_lang', this.lang)
      this.$router.go()
    }
  }
}
</script>

<style scoped>
.tag {
  cursor: pointer;
}
.white {
  color: white;
}
.orange {
  font-family: 'Poiret One';
  font-weight: 600;
  color:orange;
}
</style>
